import { IScheduleSlot } from '@/app/interfaces/schedule';
import { getDefaultTimeFromat } from '@/app/utility/date';
import { breakWords, pluralFormat } from '@/app/utility/helpers';
import { getSpecialistUrl } from '@/app/utility/navigation';
import { defaultProcessText } from 'app/utility/textProcessing';
import ImageBg from 'app/components/common/ImageBg';
import classNames from 'classnames';
import Link from 'next/link';

export default function CalendarCard({
  start_date,
  duration,
  capacity,
  service_title,
  specialist
}: IScheduleSlot) {
  const isSpecialistPreviewOnly = specialist.status === 'preview';

  return (
    <div className="p-3 bg-white rounded flex flex-col gap-4">
      <div className="flex justify-between text-p3">
        <span>{getDefaultTimeFromat(start_date)}</span>
        <span>
          {pluralFormat(duration, {
            singular: 'минута',
            plural: 'минут',
            pluralSmall: 'минуты'
          })}
        </span>
      </div>
      <div className="flex-grow justify-between flex flex-col gap-10">
        {!!service_title && (
          <div
            className="text-p3"
            dangerouslySetInnerHTML={{
              __html: defaultProcessText(
                service_title || specialist.grade || ''
              )
            }}
          ></div>
        )}
        {!service_title && !!specialist.grade && (
          <div
            className="text-h1 lg:text-h2 xl:text-h1"
            dangerouslySetInnerHTML={{
              __html: defaultProcessText(specialist.grade)
            }}
          ></div>
        )}

        <div className="flex flex-col gap-3">
          <div className="flex justify-between items-end gap-4">
            <div
              className="mt-7 text-p2 lg:text-p3 xl:text-sm break-words"
              dangerouslySetInnerHTML={{
                __html: defaultProcessText(breakWords(specialist.name))
              }}
            ></div>
            {!!specialist.image_preview?.[0]?.url && (
              <Link
                href={
                  isSpecialistPreviewOnly ? '' : getSpecialistUrl(specialist)
                }
                className={classNames('w-10 lg:w-6 xl:w-10 shrink-0', {
                  'pointer-events-none': isSpecialistPreviewOnly
                })}
              >
                <div className="relative pb-[140%] rounded lg:rounded-md xl:rounded">
                  <div className="absolute inset-0 opacity-80">
                    <ImageBg
                      src={specialist.image_preview[0].url}
                      alt={specialist.name}
                      fill
                      placeholderDataURL={
                        specialist.image_preview[0].placeholder_data_url
                      }
                      className="object-cover rounded lg:rounded-md xl:rounded"
                    />
                  </div>
                </div>
              </Link>
            )}
          </div>

          {!!capacity && (
            <div className="self-start text-white rounded-sm py-0.5 px-1 text-h2 bg-green">
              {pluralFormat(capacity, {
                singular: 'место',
                plural: 'мест',
                pluralSmall: 'места'
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
